import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

export default function OurMission() {
  const { t } = useTranslation("about");
  const features = t("mission.features", { returnObjects: true });

  return (
    <OurMissionWrap>
      <OurMissionTitle>{t("mission.title")}</OurMissionTitle>
      <OurMissionText>
        <p>{t("mission.summary")}</p>
      </OurMissionText>
      <OurMissionTitle>{t("mission.howTitle")}</OurMissionTitle>
      <OurMissionText>
        <p>{t("mission.howIntro")}</p>
        <p>{t("mission.featuresIntro")}</p>
        {features.map((feature) => (
          <p key={feature.title}>
            <strong>{feature.title}</strong>
            <br />
            {feature.body}
          </p>
        ))}
        <p>{t("mission.conclusion")}</p>
      </OurMissionText>
    </OurMissionWrap>
  );
}

const OurMissionWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  align-items: flex-start;
  margin-top: 40px;
  font-family: "Roboto", sans-serif;
`;
const OurMissionTitle = styled.h1`
  font-size: xx-large;
`;

const OurMissionText = styled.div`
  font-size: larger;
  padding: 20px 450px 20px 20px;
  display: flex;
  text-align: left;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  p {
    margin-bottom: 20px;
    line-height: normal;
    width: 80%;
  }

  @media (max-width: 1268px) {
    padding: 20px 20px 20px 20px;
    p {
      width: 100%;
    }
  }
  @media (max-width: 768px) {
    padding: 20px 20px 20px 20px;

    p {
      width: 100%;
    }
  }
`;

OurMission.displayName = "OurMission";
